import React, { useState, useEffect } from 'react';
import { Form, Select } from 'antd';
import { CloseCircleOutlined } from '@ant-design/icons';
import './moduleListSort.css';
import PropTypes from 'prop-types';

import approveImg from '../../public/img/newMain/Approve.png';
import resetWhite from '../../public/img/newMain/resetWhite.png'
/**
 * 消息提示组件
 * props传参如下
 * 消息提示类型,样式 ['error','success','warning','info']
 *                              error:错误提示框，红色样式
 *                              success:成功提示框，绿色样式
 *                              warning:警告提示框，黄色样式
 *                              info:普通提示框，蓝色样式
 */
let ModuleListSort = ({ onOpenChange, isReset }) => {
    const [form] = Form.useForm();

    const [selectedConditions, setSelectedConditions] = useState({});
    const [sortOptions, setSortOptions] = useState([]);
    const [jobPostModel, setJobPostModel] = useState({});

    /**
     * 标题默认值处理
     */
    useEffect(() => {
        setSortOptions([
            {
                label: "",
                value: ""
            },
            {
                label: "Module Code",
                value: "module_code"
            },
            {
                label: "Module Name",
                value: "module_name"
            },
            {
                label: "Cohort Year",
                value: "cohort_year"
            },
        ])
    }, []);

    useEffect(() => {
        if (isReset) {
            reset()
        }
    }, [isReset])


    const handleChange = (selectedOption) => {
        form.setFieldValue('orderBy', selectedOption)
    };

    const save = () => {
        form.validateFields().then(() => {
            selectedConditions['jobPostStatus'] ? jobPostModel.jobPostStatusList = selectedConditions['jobPostStatus'] : "";
            selectedConditions['jobApplStatus'] ? jobPostModel.jobPostStatusListSearch = selectedConditions['jobApplStatus'] : "";
            jobPostModel.applyDateStartDate = form.getFieldValue('startDate');
            jobPostModel.applyDateEndDate = form.getFieldValue('endDate');
            jobPostModel.orderBy = form.getFieldValue('orderBy');
            onOpenChange(false, true, jobPostModel)
        })
    }

    const reset = () => {
        setSelectedConditions({});
        form.resetFields()
        setJobPostModel({})
    }

    const close = () => {
        onOpenChange(false, false)
    }

    return (
        <div className='moduleStudentListSort'>
            <Form form={form}>
                <div>
                    <div className='closePopover' onClick={close}><CloseCircleOutlined /></div>
                    <div className="websiteSysRow">
                        <div className="websiteSysCol">
                            <div className="websiteSysParam ">Sort By:</div>
                            <div className="websiteSysInput">
                                <Form.Item
                                    name="orderBy"
                                >
                                    <Select
                                        onChange={handleChange}
                                        options={sortOptions}
                                    />
                                </Form.Item>
                            </div>
                        </div>
                    </div>
                </div>
            </Form>
            <div className='butArea'>
                <div className='saveButton' onClick={save}><img src={approveImg} />Confirm</div>
                <div className='resetButton' onClick={reset}><img src={resetWhite} />Reset</div>
            </div>

        </div>
    )

}
ModuleListSort.propTypes = {
    onOpenChange: PropTypes.func.isRequired,
    isReset: PropTypes.bool.isRequired,
};
export default ModuleListSort;